/**
 * Takes an array of strings combines the values to be comma separated
 * while handling the logic of one item in the array and leaving off the comma
 * from the last string.
 *
 * @param {Array} arr
 * @returns String
 */
export const reduceCommaSeparatedString = (arr = []) => {
  if (!Array.isArray(arr)) return '';
  if (arr.length === 0) return '';
  if (arr.length === 1) return arr[0];
  let string = '';
  for (let i = 0; i < arr.length; i += 1) {
    if (i !== 0) {
      string += ', ';
    }
    string += `${arr[i]}`;
  }
  return string;
};
